import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getTargetAPI = params => common.requestRaw(apiUrl + 'Target', params, 'get');
export const postTargetAPI = params => common.requestRaw(apiUrl + 'Target', params, 'post');
export const putTargetAPI = params => common.requestRaw(apiUrl + 'Target', params, 'put');
export const deleteTargetAPI = params => common.requestRaw(apiUrl + 'Target', params, 'delete');

export const putTagTargetAPI = params => common.requestRaw(apiUrl + 'TagTarget', params, 'put');
export const postTagTargetAPI = params => common.requestRaw(apiUrl + 'TagTarget', params, 'post');
export const deleteTagTargetAPI = params => common.requestRaw(apiUrl + 'TagTarget', params, 'delete');
// [대상자 상세] 훈련이력
export const getTargetExamListAPI = params => common.requestRaw(apiUrl + 'Target/ExamHistory', params, 'get');
// [대상자 상세] 선택 대상자들의 훈련 이력
export const getMergeDetailAPI = params => common.requestRaw(apiUrl + 'Target/MergeDetail', params, 'get');

// 대상자 일괄 엑셀 양식 업로드
export function postTargetExcelAPI(formData) {
  return axios({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: apiUrl + 'Target/Upload',
    data: formData
  });
}

// 대상자 내보내기 엑셀 다운로드
export function exportTargetAPI(params) {
  return axios({
    method: 'post',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats'
    },
    responseType: 'arraybuffer',
    url: apiUrl + 'Target/Export',
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/script/libs/targetLib.js